const initialState = {
    version: undefined,
    baseUrl: undefined
};

const progenyInfo = (state = initialState, action) => {
    switch (action.type) {
        default:
            return state;
    }
};

export default progenyInfo;